import { render, staticRenderFns } from "./title-format-cmp.vue?vue&type=template&id=2bfc25a5&scoped=true"
import script from "./title-format-cmp.vue?vue&type=script&lang=js"
export * from "./title-format-cmp.vue?vue&type=script&lang=js"
import style0 from "./title-format-cmp.vue?vue&type=style&index=0&id=2bfc25a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc25a5",
  null
  
)

export default component.exports